// 环境配置
const ENV = {
	DEV: 'development',
	PROD: 'production'
}

// 当前环境，可以根据实际需求修改
const currentEnv = ENV.DEV

// 环境配置对象
const config = {
	// 开发环境配置
	[ENV.DEV]: {
		// baseURL: 'http://127.0.0.1:5173/prod-api/system',
		baseURL: 'https://xq-openapi.ledrift.net',
		timeout: 15000,
		maxRetries: 2
	},
	// 生产环境配置
	[ENV.PROD]: {
		baseURL: 'https://xq-openapi.ledrift.net',
		timeout: 15000,
		maxRetries: 2,
	}
}

// 导出当前环境的配置
export default config[currentEnv]
